// frontend/src/pages/WebEmail.jsx
import { useEffect, useMemo, useState } from "react";
import Page from "../ui/Page";
import { Button } from "../ui/UIComponents";

function formatDate(d) {
  const dt = typeof d === "string" ? new Date(d) : d;
  const s = dt.toLocaleString();
  return Number.isNaN(dt.getTime()) ? (d || "") : s;
}

export default function WebEmail() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [selected, setSelected] = useState(null); // { messageId, subject, date }

  async function load() {
    setLoading(true);
    setErr("");
    try {
      const r = await fetch("/api/grabemail", { cache: "no-store" });
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || "Failed to load");
      setEmails(Array.isArray(j.items) ? j.items : []);
    } catch (e) {
      setErr(e.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  const count = useMemo(() => emails.length, [emails]);

  function handleSelect(m) {
    const picked = {
      messageId: m.messageId ?? null, // can be null for some forwards; we’ll add a hash fallback later
      subject: m.subject,
      date: m.date,
    };
    setSelected(picked);
    // Copy for convenience while we defer DB wiring
    try {
      navigator.clipboard?.writeText(JSON.stringify(picked, null, 2));
    } catch {}
    // Dev visibility
    console.log("Selected Email:", picked);
  }

  return (
    <Page>
      <main>
        <h1 className="menu-title">Web Email</h1>

        <div className="box" style={{ marginBottom: 12 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <div>
              <strong>Xem nhanh email mua hàng</strong> / Quick view of purchase emails
              <div style={{ fontSize: 12, opacity: 0.75 }}>
                Nguồn: máy chủ thư (POP3/IMAP) / Source: mail server (POP3/IMAP)
              </div>
            </div>
            <div>
              <Button onClick={load} disabled={loading}>
                {loading ? "Đang tải… / Loading…" : "Làm mới / Refresh"}
              </Button>
            </div>
          </div>
        </div>

        {/* Selected email preview (uses same .box style) */}
        {selected && (
          <div className="box" style={{ marginBottom: 10 }}>
            <strong>Selected Email:</strong>
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
{JSON.stringify(selected, null, 2)}
            </pre>
          </div>
        )}

        {err && (
          <div className="box" style={{ marginBottom: 10, color: "crimson" }}>
            Lỗi: {err}
          </div>
        )}

        {loading && !emails.length ? (
          <div className="box" style={{ opacity: 0.8 }}>Đang tải… / Loading…</div>
        ) : count === 0 ? (
          <div className="box" style={{ opacity: 0.8 }}>
            Không có email để hiển thị / No emails to show
          </div>
        ) : null}

        <div style={{ display: "grid", gap: 10 }}>
          {emails.map((m) => (
            <article
              key={m.uid || m.id}
              className="box"
              style={{ display: "grid", gap: 6, cursor: "pointer" }}
              role="button"
              tabIndex={0}
              onClick={() => handleSelect(m)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleSelect(m)}
              title="Click to select this email"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 10,
                  alignItems: "baseline",
                  flexWrap: "wrap",
                }}
              >
                <h3 style={{ margin: 0, fontSize: 16 }}>
                  {m.subject || "(no subject)"}
                </h3>
                <div style={{ fontSize: 12, opacity: 0.7 }}>
                  {formatDate(m.date)}
                </div>
              </div>
              <div style={{ fontSize: 14, opacity: 0.9 }}>
                <strong>From:</strong> {m.from || "(unknown)"}
              </div>
            </article>
          ))}
        </div>
      </main>
    </Page>
  );
}
